import { render, staticRenderFns } from "./AiUsage.vue?vue&type=template&id=f56916da&scoped=true&"
import script from "./AiUsage.vue?vue&type=script&lang=js&"
export * from "./AiUsage.vue?vue&type=script&lang=js&"
import style0 from "./AiUsage.vue?vue&type=style&index=0&id=f56916da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56916da",
  null
  
)

export default component.exports